import React from "react";

const CustomReportTable = ({ columns = [], rows = [], rowCount = 0, truncated = false }) => {
  if (columns.length === 0) {
    return (
      <div className="flex items-center justify-center h-40 text-sm text-667085">
        Run a query to see results
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full">
      <div className="flex items-center justify-between px-4 py-2 bg-F2F4F5 border-b border-EAECF0">
        <span className="text-xs fw_500 text-344054">
          Results: {rowCount.toLocaleString()} rows
          {truncated && <span className="text-FFBA08 ml-2">(truncated to 10,000)</span>}
        </span>
      </div>
      <div className="flex-1 overflow-auto">
        <table className="w-full border-collapse">
          <thead className="sticky top-0 bg-[var(--list-table-heading-bg)] z-10">
            <tr>
              {columns.map((col, idx) => (
                <th
                  key={idx}
                  className="px-3 py-2 text-left text-xs fw_600 text-white border-b border-EAECF0 whitespace-nowrap"
                >
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan={columns.length} className="px-3 py-8 text-center text-sm text-667085">
                  No data returned
                </td>
              </tr>
            ) : (
              rows.map((row, rowIdx) => (
                <tr
                  key={rowIdx}
                  className="hover:bg-f3f8ff border-b border-EAECF0"
                >
                  {columns.map((col, colIdx) => (
                    <td
                      key={colIdx}
                      className="px-3 py-2 text-xs text-344054 whitespace-nowrap max-w-xs truncate"
                      title={row[col]?.toString() || ""}
                    >
                      {row[col] !== null && row[col] !== undefined ? row[col].toString() : ""}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CustomReportTable;
